import { createAction } from "@reduxjs/toolkit";

import type { RunEventHandlersPayload } from "legacy/constants/ActionConstants";

export const runEventHandlers =
  createAction<RunEventHandlersPayload>("RUN_EVENT_HANDLERS");

export const runEventHandlersSuccess = createAction(
  "RUN_EVENT_HANDLERS_SUCCESS",
  (callbackId?: string) => ({
    payload: { callbackId },
  }),
);

export const runEventHandlersError = createAction(
  "RUN_EVENT_HANDLERS_ERROR",
  (callbackId?: string) => ({
    payload: { callbackId },
  }),
);

export const selectWidgets = createAction(
  "SELECT_WIDGETS",
  (
    widgetIds: string[],
    selectingMultiple?: boolean,
    forceNavigateInPropertyPane?: boolean,
  ) => ({
    payload: { widgetIds, selectingMultiple, forceNavigateInPropertyPane },
  }),
);

export const focusWidget = createAction(
  "FOCUS_WIDGET",
  (widgetId?: string) => ({
    payload: { widgetId },
  }),
);

export const switchTab = createAction(
  "SWITCH_TAB",
  (tabsId: string, tabId: string) => ({
    payload: { tabsId, tabId },
  }),
);

export const showModal = createAction(
  "SHOW_MODAL",
  (
    id: string,
    showModalOptions: {
      showPropertyPane: boolean;
      isSelectingMultiple?: boolean;
      doNotSelect?: boolean;
      isRouteInitiated?: boolean;
    } = {
      showPropertyPane: true,
      isSelectingMultiple: false,
      doNotSelect: false,
      isRouteInitiated: false,
    },
  ) => {
    return {
      payload: {
        modalId: id,
        showPropertyPane: showModalOptions.showPropertyPane,
        isSelectingMultiple: showModalOptions.isSelectingMultiple,
        doNotSelect: showModalOptions.doNotSelect,
        isRouteInitiated: showModalOptions.isRouteInitiated,
      },
    };
  },
);

export const closeModal = createAction(
  "CLOSE_MODAL",
  (modalName?: string, exclude?: string) => ({
    payload: { modalName, exclude },
  }),
);
export const closeAllModals = () => closeModal();

export const deleteWidgets = createAction(
  "WIDGET_DELETE",
  ({
    widgetIds,
    isShortcut,
    disallowUndo = false,
    skipSave = false,
  }: {
    widgetIds: string[] | undefined;
    isShortcut: boolean;
    disallowUndo?: boolean;
    skipSave?: boolean;
  }) => ({
    payload: {
      widgetIds,
      isShortcut,
      disallowUndo,
      skipSave,
    },
  }),
);

export const deleteEntityFromWidgets = createAction(
  "DELETE_ENTITY_FROM_WIDGETS",
  (entityName: string) => ({
    payload: { entityName },
  }),
);

export const groupSelectedWidgets = createAction("GROUP_SELECTED_WIDGETS");

export const updateTableRows = createAction(
  "UPDATE_TABLE_ROWS",
  (
    widgetId: string,
    rows: Record<number, Record<string, unknown>>,
    options?: { absoluteIndices: boolean },
  ) => ({
    payload: { widgetId, rows, options },
  }),
);

export const deleteTableRows = createAction(
  "DELETE_TABLE_ROWS",
  (widgetId: string, rows: number[]) => ({
    payload: { widgetId, rows },
  }),
);

export const insertTableRows = createAction(
  "INSERT_TABLE_ROWS",
  (widgetId: string, startIndex: number, rows: Record<string, unknown>[]) => ({
    payload: { widgetId, startIndex, rows },
  }),
);
